import React from "react";

export function Placeholder() {
    return <div className="data-form-table-header__placeholder" aria-hidden/>;
}